module.exports = __webpack_public_path__ + "img/title-2.38c0f584.png";